import { Box } from '@mui/material'

import Offer from '#/views/subscription/ui/offer'

import { IOffer } from '../api'

import styles from './subscription.module.scss'

interface PlansSectionProps {
    offers: IOffer[] | null
    currentOfferUID: string
    currentPlanTokens: number
}

export const PlansSection = ({
    offers,
    currentOfferUID,
    currentPlanTokens,
}: PlansSectionProps) => {

    return (
        <Box width='100%' textAlign='start' marginTop={'50px'}>
            <Box className={styles.blocksMapper}>
                {offers?.map((offer, idx) => {
                    return (
                        <Offer
                            {...offer}
                            device={'desktop'}
                            isCurrentSubscription={offer.uid === currentOfferUID}
                            index={idx}
                            key={offer.uid}
                            currentPlanTokens={currentPlanTokens}
                        />
                    )
                })}
            </Box>
        </Box>
    )
}

